// UserCard.jsx
import React from "react";
import { Icon } from "@iconify/react";
import { useHistory } from "react-router-dom";
import "./User.scss"; // Make sure to import your CSS file
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import commObj from "../../../constants/Common";
import { CreditCardIcon } from "../../../../assets";
export const UserCard = ({ handleShow, data }) => {
  const {
    user_first_name,
    user_last_name,
    // svcf_desc,
    country,
    city,
    user_phone_nbr,
    gender_id,
    addr_street1,
    user_profile_id,
    user_email,
  } = data;
  const history = useHistory();

  // const shouldText = svcf_desc && svcf_desc.length > 100;
  const gender = gender_id === 1 ? "Male" : "Female";
  // const displayText = showMore
  //   ? svcf_desc
  //   : `${(svcf_desc || "").slice(0, 100)}${shouldText ? "..." : ""}`;

  // const toggleShowMore = () => {
  //   setShowMore(!showMore);
  // };

  const handleEdit = () => {
    history.push({
      pathname: "/dashboard/profile",
      state: { userData: data }, // Ensure data contains the necessary user info
    });
  };

  const user_phone_nbrf = commObj.formatPhoneNumber(user_phone_nbr, "ZW");

  return (
    <div className="facility patient-card">
      <div
        className="d-flex justify-content-between align-items-center !pb-3 !mb-4"
        style={{ borderBottom: "1px solid #E7E7E9" }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <div className="rounded-5 border-slate-300 align-items-center justify-content-center d-flex bankCard_creditCardIcon">
            <CreditCardIcon />
          </div>
          <div>
            <h6 className="card-title mb-0">{`${user_first_name} ${user_last_name}`}</h6>
            <small>#{user_profile_id}</small>
          </div>
          <p className="my-auto right-align">
            {data.sys_active_yn === "Y" ? (
              <span className="green">ACTIVE</span>
            ) : (
              <span className="red">INACTIVE</span>
            )}
          </p>
        </div>
        <div className="icons">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">Edit User</Tooltip>}
          >
            <Icon
              onClick={handleEdit}
              icon="fluent:edit-48-filled"
              color="red"
              className="cursor-pointer"
            />
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip-top">
                {data.sys_active_yn === "Y" ? "Delete User" : "Restore User"}
              </Tooltip>
            }
          >
            <Icon
              onClick={handleShow}
              icon={
                data.sys_active_yn === "Y"
                  ? "mingcute:delete-fill"
                  : "fluent:person-add-24-filled"
              }
              color={data.sys_active_yn === "Y" ? "red" : "green"}
              className="cursor-pointer"
            />
          </OverlayTrigger>
        </div>
      </div>

      <div className="relative">
        <div className="sub-title">
          <span>Gender:</span> <p>{gender}</p>
        </div>
        <div className="sub-title">
          <span>Mobile No:</span> <p className="truncate">{user_phone_nbrf}</p>
        </div>
        <div className="sub-title">
          <span>Email:</span> <p className="truncate">{user_email}</p>
        </div>
        <div className="sub-title">
          <span>Address:</span> <p className="truncate">{addr_street1}</p>
        </div>
        <div className="sub-title">
          <span>City Name:</span> <p className="truncate">{city}</p>
        </div>
        <div className="sub-title">
          <span>Country:</span>
          <p className="truncate"> {country}</p>
        </div>
      </div>
    </div>
  );
};
